/**
 * Which artwork a silhouette draws, and in whose coordinate space.
 *
 * The four vendored files are data; this is the one place that says a `front` `female` figure is
 * `BODY_FEMALE_FRONT` inside `-50 -40 734 1538`. Keeping the viewBox HERE rather than in the
 * component is the point: a path string means nothing without the box it was authored in, and the
 * four boxes are not the same — the male pair is a single 724×1448 drawing whose back half sits at
 * an x offset of 724, and the female pair was authored twice, at two different sizes.
 */

import { BODY_BACK } from './bodyBack';
import { BODY_FEMALE_BACK } from './bodyFemaleBack';
import { BODY_FEMALE_FRONT } from './bodyFemaleFront';
import { BODY_FRONT } from './bodyFront';
import type { BodyPartArtwork } from './bodyArtwork';

/** Which figure to draw. `Other` and an unknown sex take the male one — see `silhouetteGender`. */
export type BodyGender = 'male' | 'female';

export interface BodySilhouetteArt {
  readonly viewBox: string;
  readonly parts: readonly BodyPartArtwork[];
}

const ART: Readonly<Record<BodyGender, Record<'front' | 'back', BodySilhouetteArt>>> = {
  male: {
    front: { viewBox: '0 0 724 1448', parts: BODY_FRONT },
    back: { viewBox: '724 0 724 1448', parts: BODY_BACK },
  },
  female: {
    front: { viewBox: '-50 -40 734 1538', parts: BODY_FEMALE_FRONT },
    back: { viewBox: '756 0 774 1448', parts: BODY_FEMALE_BACK },
  },
};

export function bodySilhouetteArt(gender: BodyGender, side: 'front' | 'back'): BodySilhouetteArt {
  return ART[gender][side];
}
